import React from 'react'
import { useState, FormEvent } from 'react'
import logo1 from '../../../ASSETS/tourisme/Image/LOGO.png'
import { Link, useNavigate} from 'react-router-dom'
//import Header from '../../COMPONNENT/Header/Header';
// import Africa from '../../../ASSETS/tourisme/Image/A.D 2.png'
import { useEffect } from 'react';
import Loading from '../../../TOURISME/COMPONENTS/Loading/Loading'
import rdv2_barniere from '../../../ASSETS/CaImmigration/images/rdv2_barniere.png'
import { ToastContainer, toast } from "react-toastify"
// import Register from "../../../API/inscription/Inscription"
import left from "../../../ASSETS/CaImmigration/icones/back.png"
//import Footer from '../../COMPONNENT/Footer/Footer';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ACH from "../../../API/tourisme/achat/achat";

function Achat() {
  //Spécification du type des données reçues de l'API
  interface Item {
    Items_Numbers: number;
    Categories:	number;
    Names: string;
    fr_Name: string;	
    Types:	string;
  }

  //localStorage.setItem('url', JSON.stringify('/appointement/RendezVousService'));

  const [data, setData] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("data");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    return initialValue;
  });

  const [url, setUrl] = useState(() => {
    // getting stored value
    const link = localStorage.getItem("url");
    const value = link !== null ? JSON.parse(link) : null;
    return value;
  });
  
    let votrenom = null;

    if(data !== null && data.userLastname !== null && data.userName !== null )
      {
        votrenom = data.userLastname + ' ' + data.userName;
      }
  
      if(data !== null && data.userLastname !== null && data.userName === null)
      {
        votrenom = data.userLastname;
      }
      if(data !== null && data.userName !== null && data.userLastname === null)
      {
        votrenom = data.userName;
      }
    //console.log(data)
    const navigate = useNavigate();
    
    const [nom, setNom] = useState(votrenom || "")
    const [dateD, setDateD] = useState("")
    const [dateA, setDateA] = useState("")
    const [tel, setTel] = useState(data !== null ? data.userTel : "" )
    const [sujet, setSujet] = useState("")
    const [usermail, setUserEmail] = useState(data !== null ? data.userMail : "" )
    const [sujetItem, setSujetItem] = useState<Item[]>([]);
    const [sujets, setSujets] = useState<Item[]>([]);
    const [msg, setMsg] = useState("")
    const [comp,setComp] = useState("")
    const [villeD,setVilleD] = useState("");
    const [villeA,setVilleA] = useState("");

    interface Errors {
        [key:string]: string[]
    }
    const [errors,setErrors] = useState<Errors>({})

  
    const [loading, setLoading] = useState(true);
    const id=useParams()
    useEffect(() => {
        //récupération du service par rapport à son id
        if(id)
            {
            axios.get(`${process.env.REACT_APP_BASE_URL}/api/items/${id.item_id}`)
              .then(response => {
                  // Mettez à jour l'état avec les données récupérées
                  setSujetItem(response.data.data);
                  setSujet(response.data.data[0].fr_Name)
                  //console.log(response.data.data);
              })
            .catch(err => console.log(err));
        }

              //récupération de tous les services
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/items`)
              .then(response => {
                  // Mettez à jour l'état avec les données récupérées
                  setSujets(response.data.data);
                  //console.log(response);
              })
              .catch(err => console.log(err));
        //const user = localStorage.getItem('userNumber');
        //console.log(user);
        if (!data) {
            navigate("/Connexion");
            return;
        }
        //fetchData();
        //console.log(res);
        const timer = setTimeout(() => {
            // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
            setLoading(false);
        }, 1000); // 5000 millisecondes = 5 secondes
        // Nettoyer le timer si le composant est démonté avant la fin du délai
        
        return () => clearTimeout(timer);
    },[]);
  
    
    function submit(e: FormEvent) {
      e.preventDefault()

      // console.log(sujet)
      var templateParams = {
          nom: nom,
          usermail: usermail,
          tel: tel,
          dateD: dateD,
          dateA: dateA,
          comp: comp,
          user: data.userId,
          villeD: villeD,
          villeA: villeA
      };
     
      //console.log(templateParams)
      ACH.submitForm(templateParams)
        .then((res: any) => {
          if (res.data.status === 201) {
              toast.success(res.data.message);
              navigate("/hometourisme");
              //console.log(res);
              // navigate(url);
              // url !== null ? navigate(url)  : navigate('/');
          } else if(res.data.status === 422){
               setErrors(res.data.errors)
          }
           else {
              toast.error(res.data.message);
              console.log(res);
          }
      })
      .catch((err: any) => {
          toast.error('Erreur merci de reessayer !');
          console.log(err);
      })
      .finally(() => {
          setLoading(false);
      })
  }
    const today = new Date().toISOString().split('T')[0];

    const {t} = useTranslation() as {t: (key:string)=>string}
 
  return (
    <div>
          {
              loading ? (
                // Afficher le spinner tant que loading est true
                <Loading />
              ) : (
                <>
          {/* <Header/> */}
          
          <div>
            <ToastContainer />
          </div>
          <Link to='/hometourisme'>
            <div className='relative flex items-center ml-6 space-x-2 top-8'>
              <img src={left} className='w-4' alt='arrow_left'/>
              <p className='text-lg text-[#233D4D] hover:text-[#fe7f2d]'>{t("Retour à la page d'accueil")}</p>
            </div>
          </Link>

          <div className='flex items-center justify-center my-20 xs:flex-row s:flex-col-reverse '>
            <div className='relative bg-white shadow-3xl' style={{ height: 926, width: 462 }}>
                {/* Image de fond */}
              <img src={rdv2_barniere} className='absolute inset-0 object-cover w-full h-full' alt='Bannière de rendez-vous' />
                {/* Contenu au-dessus de l'image */}
              <div className='absolute inset-0 flex flex-col items-center justify-center'>
                  <p hidden className='pt-24 text-3xl font-bold text-center text-white'>{t("Bienvenue")} !</p>
                <div className='flex justify-center pt-10'>
                  <p className='pl-5 pr-5 text-4xl font-bold text-center text-white pt-30'>
                  {t("Formulaire d'Achat de Billet")}
                    {/* <em className='text-[#fe7f2d]'>
                      <br />{sujet ? sujet : ""}
                    </em> */}
                  </p>
                </div>
              </div>
            </div>

            <div className='bg-white shadow-3xl xs:w-[500px] s:w-[310px] h-auto'>
                {/* logo */}
                <Link to='/'>
                <div style={{ borderBottomRightRadius: "100px" }} className='w-40 pb-4 pr-4 bg-white sm:pl-5 s:pl-2'>
                    <img src={logo1} className='h-16 pt-6 s:pl-0 ' alt='logo' />
                </div>
                </Link>
                <p className='text-2xl font-bold text-[#fe7f2d] text-center relative s:bottom-5 xs:bottom-14'>{t("Achat de Billet d'Avion")} </p>

                <p  className='relative font-thin text-center mx-5 xs:bottom-10 s:bottom-5'>
                  {t("Veuillez remplir tous les champs du formulaire afin d'obtenir une cotation de billet d'avion")}
                 </p>
              <form action="" onSubmit={submit}>
                <div className='relative flex flex-col items-center pt-6 space-y-4 bottom-10'>

                        {/*Nom */}
                        <div className='flex flex-col space-y-3'>
                            <label className='text-lg'>{t("Nom & Prénom")} <span className='text-red-600'>*</span></label>
                            <input type='hidden' value={data.userId} required />
                            <input name='name' type='text' 
                              style={{ 
                                backgroundColor: "#f3f3f3", 
                                border: "0px solid #fe7f2d",
                                outline: "none",
                                
                            }} 
                            value={nom} onChange={(e) => setNom(e.currentTarget.value)}
                            className='border-none s:w-[280px] xs:w-[360px] focus:outline-none h-9'  placeholder={t('Nom prénom')} />
                            {errors.nom &&  <p className='text-red-500' >{errors.nom}</p> } 
                        </div>

                        {/* Mail */}
                        <div className='flex flex-col space-y-3'>
                            <label className='text-lg'>{t("Adresse e-mail")} <span className='text-red-600'>*</span></label>
                            <input name='mail' type='email' placeholder={t('Adresse e-mail')} 
                              style={{ 
                                backgroundColor: "#f3f3f3", 
                      
                                border: "0px solid #fe7f2d",
                               
                                outline: "none",
                                
                            }} 
                            value={usermail} onChange={(e) => setUserEmail(e.currentTarget.value)}
                            className='border-none s:w-[280px] xs:w-[360px] focus:outline-none h-9' />
                            {errors.usermail && <p className='text-red-500'>{errors.usermail}</p>}
                        </div>
                  
                        {/* portable */}
                        <div className='flex flex-col space-y-3'>
                            <label className='text-lg'>{t("Numéro de portable")} <span className='text-red-600'>*</span></label>
                            <input name='numero' type='tel' placeholder={t('Telephone')} 
                              style={{ 
                                backgroundColor: "#f3f3f3", 
                                border: "0px solid #fe7f2d",
                                outline: "none",
                            }} 
                            value={tel} onChange={(e) => setTel(e.currentTarget.value)}
                            className='border-none s:w-[280px] xs:w-[360px] focus:outline-none h-9' />
                            {errors.tel && <p className='text-red-500'>{errors.tel}</p> }
                        </div>

                         {/* Date de depart */}
                        <div className='flex flex-col space-y-3'>
                            <label className='text-lg'>{t("Date de depart")} <span className='text-red-600'>*</span></label>
                            <input name='dateD' type='date' 
                              style={{ 
                                backgroundColor: "#f3f3f3", 
                                border: "0px solid #fe7f2d",
                                outline: "none",
                            }} 
                            value={dateD} onChange={(e) => setDateD(e.currentTarget.value)}
                            className='border-none s:w-[280px] xs:w-[360px] focus:outline-none h-9'
                            min={today}
                            />
                            {errors.dateD && <p className='text-red-500'>{errors.dateD}</p>}
                        </div>

                         {/* Date d'arriver */}
                         <div className='flex flex-col space-y-3'>
                            <label className='text-lg'>{t("Date d'Arrivee")} <span className='text-red-600'>*</span></label>
                            <input name='dateA' type='date' 
                              style={{ 
                                backgroundColor: "#f3f3f3", 
                                border: "0px solid #fe7f2d",
                                outline: "none",
                            }} 
                            value={dateA} onChange={(e) => setDateA(e.currentTarget.value)}
                            className='border-none s:w-[280px] xs:w-[360px] focus:outline-none h-9'
                            min={today}
                            />
                            {errors.dateA && <p className='text-red-500'>{errors.dateA}</p>}
                        </div>

                        <div className='flex flex-col space-y-3'>
                            <label className='text-lg'>{t("Aéroport de depart")} <span className='text-red-600'>*</span></label>
                            <input name='villeD' type='text' 
                              style={{ 
                                backgroundColor: "#f3f3f3", 
                                border: "0px solid #fe7f2d",
                                outline: "none",
                                
                            }} 
                            value={villeD} onChange={(e) => setVilleD(e.currentTarget.value)}
                            className='border-none s:w-[280px] xs:w-[360px] focus:outline-none h-9'  placeholder="Aéroport de depart" />
                            {errors.villeD &&  <p className='text-red-500' >{errors.villeD}</p> } 
                        </div>

                        <div className='flex flex-col space-y-3'>
                            <label className='text-lg'>{t("Aéroport de d'arrivee")} <span className='text-red-600'>*</span></label>
                            <input name='villeA' type='text' 
                              style={{ 
                                backgroundColor: "#f3f3f3", 
                                border: "0px solid #fe7f2d",
                                outline: "none",
                                
                            }} 
                            value={villeA} onChange={(e) => setVilleA(e.currentTarget.value)}
                            className='border-none s:w-[280px] xs:w-[360px] focus:outline-none h-9'  placeholder="Aéroport de d'arrivée" />
                            {errors.villeA &&  <p className='text-red-500' >{errors.villeA}</p> } 
                        </div>

                         {/* Heure du rendez-vous */}
                        <div className='flex flex-col space-y-3'>
                            <label className='text-lg'>{t("Compagnie de preference")} </label>
                            <input name='comp' type='text' 
                              style={{ 
                                backgroundColor: "#f3f3f3", 
                                border: "0px solid #fe7f2d",
                                outline: "none",
                            }} 
                            value={comp} onChange={(e) => setComp(e.currentTarget.value)}
                            className='border-none s:w-[280px] xs:w-[360px] focus:outline-none h-9' />
                            {errors.comp && <p className='text-red-500'>{errors.comp}</p>}
                        </div>


                         {/* Sujet */}
                        {/* <div className='flex flex-col space-y-3'>
                            <label className='text-lg'>{t("Sujet")} <span className='text-red-600'>*</span></label>
                            <select value={sujet} name='sujet' onChange={(e)=>setSujet(e.currentTarget.value)} 
                            style={{ 
                              backgroundColor: "#f3f3f3", 
                              border: "0px solid #fe7f2d",
                              outline: "none",
                              }} className='border-none pl-3 s:w-[280px] xs:w-[360px] focus:outline-none h-9' >
                              
                              <option value=''>{t("Choisir un sujet")}</option>
                              {sujets.map((item, index)=>(
                                <option key={index} value={item.fr_Name}>{item.fr_Name}</option>
                              ))} 
                            </select>
                            {errors.sujet && <p className='text-red-500'>{errors.sujet}</p>}
                        </div>                         */}
                </div>

                <button className='border-[#fe7f2d] border-solid border-2 text-[#fe7f2d] ml-16 mt-4 relative bottom-12 px-10 h-10 text-lg rounded transform active:scale-75 transition-transform'>{t("Envoyer")}</button>
              </form>
            </div>
          </div>
        {/* <Footer/> */}
         </>
              
         )
          }
    </div>
  )
}

export default Achat